import _asyncToGenerator from "/opt/atlassian/pipelines/agent/build/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator";
import _regeneratorRuntime from "/opt/atlassian/pipelines/agent/build/node_modules/@babel/runtime-corejs2/regenerator";
import "core-js/modules/es6.regexp.split.js";
import "core-js/modules/es6.array.slice.js";
import "core-js/modules/es6.function.name.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { get } from 'vuex-pathify';
import { generateAiRecommendation, logEventAnalytics, shareAiRecommendation } from "../../boot/google-analytics";
import { mdRender } from "../../functions/remarkable";
export default {
  name: 'Recommend',
  components: {
    RecommendSuggestion: require('@/components/RecommendSuggestion').default
  },
  data: function data() {
    return {
      suggestion: {
        loading: false,
        value: '',
        errored: false
      }
    };
  },
  computed: {
    branchDetails: get('config/getBranchDetails'),
    submitted: get('responses/submitted'),
    companyDetails: get('config/getCompanyDetails'),
    currentSurvey: get('surveys/currentSurvey')
  },
  methods: {
    setSuggestion: function setSuggestion(suggestion) {
      var _this = this;

      if (!suggestion || this.suggestion.value) {
        return;
      } // No matter how many words there are, we want the entire 'animation' to complete within
      // 500ms so that users aren't waiting to make potential changes.


      this.suggestion.value = '';
      var words = suggestion.split(' ');
      var ms = 1200 / words.length;
      var i = 0;
      var intervalId = setInterval(function () {
        if (i <= words.length) {
          _this.suggestion.value = words.slice(0, i).join(' ');
        } else {
          clearInterval(intervalId);
        }

        ++i;
      }, ms);
    },
    loadSuggestion: function loadSuggestion() {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var _response$data, response, suggestion, name, _this2$currentSurvey, surveyId, surveyTypeId, branchId;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this2.suggestion.loading = true;
                _context.prev = 1;
                _context.next = 4;
                return _this2.$store.dispatch('answers/getRecommendSuggestion');

              case 4:
                response = _context.sent;
                suggestion = ((_response$data = response.data) === null || _response$data === void 0 ? void 0 : _response$data.response) || '';

                _this2.setSuggestion(suggestion);

                _this2.suggestion.errored = !!response.error || !suggestion; // execute gtm event for generating ai recommendation

                name = _this2.companyDetails.name;
                _this2$currentSurvey = _this2.currentSurvey, surveyId = _this2$currentSurvey.surveyId, surveyTypeId = _this2$currentSurvey.surveyTypeId;
                branchId = _this2.branchDetails.id;
                generateAiRecommendation({
                  companyName: name,
                  surveyId: surveyId,
                  surveyTypeId: surveyTypeId,
                  success: !_this2.suggestion.errored,
                  branchId: branchId
                });

              case 12:
                _context.prev = 12;
                _this2.suggestion.loading = false;
                return _context.finish(12);

              case 15:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[1,, 12, 15]]);
      }))();
    },
    onNext: function onNext(navigate) {
      if (navigate) {
        var name = this.companyDetails.name;
        var _this$currentSurvey = this.currentSurvey,
            surveyId = _this$currentSurvey.surveyId,
            surveyTypeId = _this$currentSurvey.surveyTypeId;
        var branchId = this.branchDetails.id; // execute google tag manager event for sharing the ai recommendation

        shareAiRecommendation({
          companyName: name,
          surveyId: surveyId,
          surveyTypeId: surveyTypeId,
          branchId: branchId
        }); // todo we need to alter this based on which social site we're linking to https://feeditback.atlassian.net/browse/FIB-8654
        // todo we also need to alter the wording on this page based on the social site we're linking to https://feeditback.atlassian.net/browse/FIB-8654

        window.open(this.branchDetails.aiSharingLink, '_blank').focus();
        logEventAnalytics('recommend', 'shared', this.branchDetails.aiSharingLink);
      }

      this.$router.push('/share');
    },
    onGenerate: function onGenerate() {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                logEventAnalytics('recommend', 'manually-generate', 'click');
                _context2.next = 3;
                return _this3.loadSuggestion();

              case 3:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    },
    renderText: function renderText(text) {
      return mdRender(text);
    }
  }
};